export const HOME = {
    emergentLink: "home-emergent-link",
    heroCta: "home-hero-cta",
    heroExplore: "home-hero-explore",
    statsBlock: "home-stats-block",
    themeCard: (slug) => `home-theme-card-${slug}`,
};

export const NAV = {
    root: "site-nav",
    brand: "nav-brand",
    link: (slug) => `nav-link-${slug}`,
    schoolsLink: "nav-link-schools",
    aboutLink: "nav-link-about",
    mobileToggle: "nav-mobile-toggle",
};

export const THEME = {
    page: (slug) => `theme-page-${slug}`,
    searchInput: "theme-search-input",
    schoolFilter: "theme-school-filter",
    countryFilter: "theme-country-filter",
    clearFilters: "theme-clear-filters",
    contributionCard: (id) => `contribution-card-${id}`,
    emptyState: "theme-empty-state",
};

export const SCHOOLS = {
    page: "schools-page",
    row: (idx) => `school-row-${idx}`,
    searchInput: "schools-search-input",
};

export const ABOUT = {
    page: "about-page",
    etwinningLink: "about-etwinning-link",
};
